import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972|0)(?:5\d|[2-9]|7\d)\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^https:\/\/www\.linkedin\.com\/in\//,
  email:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  identity: /^\d{9}$/,
  onlyNumbers: /^\d+$/,
  time: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/,
  // Israeli vehicle license plate — 7 or 8 digits (dashes stripped before test)
  licensePlate: /^\d{7,8}$/,
}

const messagesTranslations = {
  en: {
    makat: "Please enter a line number",
    fullNameTwo: "Please enter more than 2 letters.",
    firstName:
      "Use only English or Hebrew letters, no symbols. Max 20 characters.",
    phoneNumber: "The phone number entered is incorrect",
    email: "The email address entered is invalid",
    requiredName: "First name and last name must be filled in",
    requiredPhoneNumber: "A phone number must be entered",
    requiredEmail: "An email address must be entered",
    subject: "You must choose subject",
    lastName: "Last name must contain valid characters",
    street: "Street name is invalid",
    city: "City name is invalid",
    postalCode: "Postal code is invalid",
    poBox: "P.O Box number is invalid",
    houseNumber: "House number is invalid",
    lineNumber: "Line number is invalid",
    lineNumberRequired: "Line number is required",
    inquiryContent: "Inquiry content is required",
    identity: "Identity must be exactly 9 digits",
    identificationValue: "Identification value is required (max 30 characters)",
    customerId: "ID number must be a valid number",
    phonePrefix: "Phone prefix must be a valid number",
    requiredEventDate: "Event date is required",
    tripDirection: "Trip destination is required",
    exactEventTime: "Time must be in HH:mm format",
    dropOffDestination: "Drop off destination is required",
    eventLocation: "Event location is required",
    incidentArea: "Incident area is required",
    inquiryDescription: "Inquiry description is required (max 3000 characters)",
    settlement: "Settlement is required",
    driverPersonalNumber: "Customer number must be a valid number",
    licenseNum: "License number must be a 10 digits number",
    orderNumber: "Order number must be a number",
    lostContentId: "Lost content is required",
    lostColorId: "Lost color is required",
    dateValidity: "Date must be within the last 3 months and not in the future",
    ravkavMaxLength: "Ravkav account must be less than 255 characters",
    ravkavRequired: "Rav-Kav account is required",
    timeNotInFuture: "Time must not be in the future",
    brandName: "Brand name must be less than 25 characters",
    caseNumber: "Please enter digits only",
    caseNumberRequired: "A case number must be entered",
    phoneNumberMinimum: "Please enter up to 10 digits",
  },
  he: {
    makat: "יש להקליד מספר קו",
    fullNameTwo: "יש להקליד יותר מ 2- אותיות.",
    firstName: "השתמש באותיות בעברית או באנגלית בלבד, ללא סימנים. עד 20 תווים.",
    phoneNumber: "מספר נייד אינו תקין",
    email: "כתובת האימייל שהוזנה אינה תקינה",
    requiredName: "יש למלא שם פרטי ושם משפחה",
    requiredPhoneNumber: "יש להזין מספר טלפון",
    requiredEmail: "יש להזין כתובת מייל",
    subject: "עליך לבחור נושא",
    lastName: "שם המשפחה חייב להכיל תווים חוקיים",
    street: "שם הרחוב אינו תקין",
    city: "שם העיר אינו תקין",
    postalCode: "המיקוד אינו תקין",
    poBox: "מספר תא הדואר אינו תקין",
    houseNumber: "מספר הבית אינו תקין",
    lineNumber: "מספר הקו אינו תקין",
    lineNumberRequired: "מספר הקו נדרש",
    inquiryContent: "תוכן הפנייה נדרש",
    identity: "תעודת זהות חייבת להיות 9 ספרות",
    identificationValue: "נדרש ערך זיהוי (עד 30 תווים)",
    customerId: "מספר תעודת זהות חייב להיות מספר תקין",
    phonePrefix: "מספר הדירה חייב להיות מספר תקין",
    requiredEventDate: "תאריך האירוע נדרש",
    tripDirection: "מקום היעד נדרש",
    exactEventTime: "השעה חייבת להיות בפורמט HH:mm",
    dropOffDestination: "מקום היעד נדרש",
    eventLocation: "מיקום האירוע נדרש",
    incidentArea: "אזור האירוע נדרש",
    inquiryDescription: "תיאור הפנייה נדרש (עד 3000 תווים)",
    driverPersonalNumber: "מספר אישי לא תקין",
    licenseNum: "מספר רישיון חייב להיות 10 ספרות",
    orderNumber: "מספר הזמנה חייב להיות מספר תקין",
    lostContentId: "כינוי האובייקט נדרש",
    lostColorId: "צבע האובייקט נדרש",
    dateValidity: "התאריך חייב להיות בתוך 3 החודשים האחרונים ולא בעתיד",
    ravkavMaxLength: "מספר רבקב חייב להיות פחות מ 255 תווים",
    ravkavRequired: "יש למלא מספר רב קו",
    timeNotInFuture: "השעה חייבת להיות בעבר",
    brandName: "שם המוצר חייב להיות פחות מ 25 תווים",
    caseNumber: "יש להקליד ספרות בלבד",
    caseNumberRequired: "יש למלא מספר פניה",
    phoneNumberMinimum: "יש להקליד מספר נייד בן 10 ספרות",
  },
}

export const messagesInvalid = {
  en: messagesTranslations.en,
  he: messagesTranslations.he,
  ar: messagesTranslations.en,
  ru: messagesTranslations.en,
}

type Language = "en" | "he" | "ar" | "ru"

export const commonSchema = {
  common: (language: Language) => {
    const msg = messagesInvalid[language]
    return {
      firstName: yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .max(20, msg.firstName)
        .required(msg.requiredName)
        .min(2, msg.fullNameTwo),
      lastName: yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .max(20, msg.firstName)
        .required(msg.requiredName)
        .min(2, msg.fullNameTwo),
      email: yup
        .string()
        .max(80, msg.email)
        .matches(regex.email, msg.email)
        .required(msg.requiredEmail)
        .min(2, msg.fullNameTwo),
      phonePrefix: yup
        .string()
        .matches(regex.onlyNumbers, msg.phonePrefix)
        .max(25, msg.phonePrefix)
        .required(msg.requiredPhoneNumber)
        .min(2, msg.fullNameTwo),
      phone: yup
        .string()
        .matches(regex.onlyNumbers, msg.phoneNumber)
        .max(8, msg.phoneNumber)
        .required(msg.requiredPhoneNumber)
        .min(2, msg.fullNameTwo),
      eventDate: yup
        .date()
        .required(msg.requiredEventDate)
        // .min(subMonths(new Date(), 3), msg.dateValidity)
        .max(new Date(), msg.dateValidity),
      lineNumber: yup
        .string()
        .transform((value) => (value === "" ? undefined : value))
        .matches(/^[0-9A-Za-z\u05D0-\u05EA]+$/, msg.lineNumber)
        .max(10, msg.lineNumber)
        .required(msg.lineNumberRequired),

      tripDirection: yup
        .string()
        .max(255, msg.tripDirection)
        .required(msg.tripDirection)
        .min(2, msg.fullNameTwo),
      exactEventTime: yup
        .string()
        .matches(regex.time, msg.exactEventTime)
        .required(msg.exactEventTime),
      dropOffDestination: yup
        .string()
        .max(255, msg.dropOffDestination)
        .optional()
        .min(2, msg.fullNameTwo),
      incidentArea: yup
        .string()
        .max(50, msg.incidentArea)
        .required(msg.incidentArea)
        .min(2, msg.fullNameTwo),
      inquiryDescription: yup
        .string()
        .max(3000, msg.inquiryDescription)
        .required(msg.inquiryDescription),
      eventLocation: yup
        .string()
        .max(255, msg.eventLocation)
        .min(2, msg.fullNameTwo)
        .required(msg.eventLocation),
      customerId: yup
        .string()
        .matches(regex.onlyNumbers, msg.customerId)
        .max(25, msg.customerId)
        .min(2, msg.fullNameTwo)
        .optional(),
      ravkav: yup.string().max(255, msg.ravkavMaxLength).optional(),
      driverFirstName: yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .max(25, msg.firstName)
        .min(2, msg.fullNameTwo)
        .optional(),
      driverLastName: yup
        .string()
        .matches(regex.singleName, msg.lastName)
        .max(25, msg.lastName)
        .min(2, msg.fullNameTwo)
        .optional(),
      driverPersonalNumber: yup
        .string()
        .matches(regex.onlyNumbers, msg.driverPersonalNumber)
        .max(10, msg.driverPersonalNumber)
        .optional(),
      licenseNum: yup
        .string()
        .matches(regex.onlyNumbers, msg.licenseNum)
        .max(10, msg.licenseNum)
        .optional(),
      orderNumber: yup
        .string()
        .matches(regex.onlyNumbers, msg.licenseNum)
        .required(msg.orderNumber),
      lostContentId: yup.number().required(msg.lostContentId),
      lostColorId: yup.number().required(msg.lostColorId),
      brandName: yup.string().max(25, msg.brandName).min(2, msg.fullNameTwo),
      kosherPhone: yup.boolean(),
      caseNumber: yup
        .string()
        .matches(regex.onlyNumbers, msg.caseNumber)
        .required(msg.caseNumberRequired),
      phoneLostStatus: yup
        .string()
        .matches(regex.onlyNumbers, msg.caseNumber)
        .max(7, msg.phoneNumberMinimum)
        .required(msg.requiredPhoneNumber)
        .min(7, msg.phoneNumberMinimum),
    }
  },
}

export const generateSchema = (language: Language) => {
  const msg = messagesInvalid[language]

  return yup.object({
    fullname: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .required(msg.requiredName)
      .min(2, msg.requiredName)
      .test("min-words", "נא להזין שם פרטי ושם משפחה", (value) => {
        if (!value) return false
        const words = value
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0)
        return words.length >= 2
      })
      .test("min-letters", "יש להקליד יותר מ 2- אותיות.", (value) => {
        if (!value) return false
        const words = value
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0)
        return words.every((word) => word.length >= 2)
      }),
    firstName: yup
      .string()
      .matches(regex.singleName, msg.firstName)
      .max(50, msg.firstName)
      .required(msg.requiredName),
    lastName: yup
      .string()
      .matches(regex.singleName, msg.lastName)
      .max(50, msg.lastName)
      .required(msg.requiredName),
    email: yup
      .string()
      .matches(regex.email, msg.email)
      .required(msg.requiredEmail),
    phone: yup
      .string()
      .matches(regex.allPhoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    phonehe: yup
      .string()
      .matches(regex.phoneNumber, msg.phoneNumber)
      .required(msg.requiredPhoneNumber)
      .max(13, msg.phoneNumber),
    identity: yup
      .string()
      .matches(regex.identity, msg.identity)
      .required(msg.identity),
    street: yup.string(),
    city: yup.string().required(msg.city),
    postalCode: yup.string(),
    poBox: yup.string(),
    houseNumber: yup.string(),
    lineNumber: yup.string(),
    inquiryContent: yup.string().required(),
    cardNumber: yup.string(),
    kosherPhone: yup.boolean(),
    subject: yup.string().min(1, msg.subject).required(msg.subject),
    pdfFile: yup.string().required("ניתן לעלות קובץ עד משקל GB 2"),
  })
}
